import Vue from 'vue'

import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
import '../public/style.css';

import Date from "@/filters/Date.js"
import DateTime from "@/filters/DateTime.js"

import MbAlert from "@/components/ui/modal/MbAlert"
import MbConfirm from "@/components/ui/modal/MbConfirm";
import MbInputSelect2 from "@/components/ui/base/MbInputSelect2"
import MbUserAvatarSelect from "@/components/patient-new/MbUserAvatarSelect"
import MbClassAvatarSelect from "@/components/class-new/MbClassAvatarSelect"
import MbContentFind from "@/components/content-find/MbContentFind"
import MbContentReport from "@/components/content/MbContentReport";
import MbContentCaption from "@/components/content/MbContentCaption"

window.vueComponents = window.vueComponents || {}

Vue.config.productionTip = false

const Widgets = {
  "mb-alert": MbAlert,
  "mb-confirm": MbConfirm,
  "mb-input-select-2": MbInputSelect2,
  "mb-user-avatar-select": MbUserAvatarSelect,
  'mb-class-avatar-select': MbClassAvatarSelect,
  'mb-content-find': MbContentFind,
  'mb-content-report': MbContentReport,
  "mb-content-caption": MbContentCaption
}

const Components = {
};

const Filters = {
  Date,
  DateTime
};

document.addEventListener("DOMContentLoaded", function() {
  Object.keys(Widgets).forEach(name => {
    var els = document.getElementsByClassName(name);
    if (els.length == 0) {
      return;
    }

    Array.prototype.forEach.call(els, el => {
      new Vue({
        render: h => h(Widgets[name])
      }).$mount(el);
    });
  });

  window.MbCreateVue("mb-alert", "page-alert");
  window.MbCreateVue("mb-confirm", "page-confirm");
});

Object.keys(Components).forEach(name => {
  Vue.component(name, Components[name]);

  if (window.Vue){
    window.Vue.component(name, Components[name]);
  }
});

Object.keys(Filters).forEach(name => {
  Vue.filter(name, Filters[name]);

  if (window.Vue){
    window.Vue.filter(name, Filters[name]);
  }
});

window.MbCreateVue = function(widgetName, selector, parameters){
  var els = document.getElementsByClassName(selector);
  if (els.length == 0){
    return;
  }

  var el = els[0];

  var ComponentClass = Vue.extend(Widgets[widgetName])
  var instance = new ComponentClass();
  for(var p in parameters){
    instance[p] = parameters[p];
  }
  instance.$mount()
  el.appendChild(instance.$el)

  window.vueComponents[selector] = instance
  return instance
}
